export const ALL = 'all'
export const ALL_FOR_ANALYSIS = 'all_for_analysis'
export const ANNOUNCEMENT = 'announcement'
export const NEWS = 'news'
